<app-page-title-bar text="Página informativa"></app-page-title-bar>

<app-page-container>
 
</app-page-container>
